<div class="coworker-profile-container">
  <div class="header">
    <div class="logout" (click)="logOut()">
      <img [src]="getLogOutProfileIcon" />
    </div>
    <h3 class="title">
      {{ "coworker.profile.title" | translate }}
    </h3>
  </div>
  <div class="container">
    <div class="user-actions">
      <!-- <ng-container *ngIf="getRole === 'coworking'"> -->
      <div class="section-user-options">
      <span class="section-label">{{
        "coworker.profile.my-profile" | translate
        }}</span>
        <cowing-list-element [label]="'coworker.profile.my-profile-title'" (event)="navigateTo('coworker-info')">
        </cowing-list-element>
        <!-- <cowing-list-element [label]="'coworker.profile.paymentmethods'" (event)="navigateTo('coworking-spaces')">
        </cowing-list-element>
        <cowing-list-element [label]="'coworker.profile.notifications'" (event)="navigateTo('coworking-services')">
        </cowing-list-element> -->
      </div>
      <div class="section-user-options">
      <span class="section-label">{{
        "coworking-profile.password" | translate
        }}</span>
        <cowing-list-element [label]="'coworker.profile.change-pwd'"
                             (event)="requestPwdRecovery()"></cowing-list-element>
      </div>

      <!-- <div class="section-user-options">
        <span class="section-label">{{
          "coworker.profile.my-credits" | translate
        }}</span>
        <cowing-list-element [label]="'coworker.profile.buy-cowings'"></cowing-list-element>

        <cowing-list-element [label]="'coworker.profile.record-cowings'"></cowing-list-element>
      </div> -->
      <div class="section-user-options">
      <span class="section-label">{{
        "coworking-profile.support" | translate
        }}</span>
        <cowing-list-element [label]="'coworker.profile.terms-conditions'"
                             (event)="openPage('https://www.cowing.es/terms-and-conditions')"></cowing-list-element>
        <cowing-list-element [label]="'coworker.profile.privacy'"
                             (event)="openPage('https://www.cowing.es/privacy-policy')"></cowing-list-element>
        <cowing-list-element [label]="'coworker.profile.community-guidelines'"
                             (event)="openPage('https://www.cowing.es/community-guidelines')"></cowing-list-element>
        <cowing-list-element [label]="'coworker.profile.FAQS'"
                             (event)="openPage('https://www.cowing.es/faqs-empleados')">
        </cowing-list-element>
      </div>
    </div>
  </div>
  <div class="tabs">
    <cowing-tabs [active]="EActiveTab.Profile"></cowing-tabs>
  </div>
</div>
